import type { DBSchema, IDBPDatabase } from "idb";
import { openDB } from "idb";

export interface LocalDbRecordingsData {
  localTimeOffset: number;
  recordedArrayBuffer: ArrayBuffer;
  recordingStartTime: number;
  recordingStopTime: number;
  sessionId: string;
  storyId: string;
  streamId: string;
  type: string;
  userId: string;
}

interface TheirStorySchema extends DBSchema {
  recordings: {
    key: string;
    value: {
      id: string;
      streamId: string;
      slice: number;
      data: LocalDbRecordingsData;
    };
  };
}

export const recordingsDB = (): Promise<IDBPDatabase<TheirStorySchema>> => {
  const { location: { hostname = "" } = {} } = window;
  const dbName =
    hostname === "staging.theirstory.io"
      ? "theirstory-staging"
      : hostname === "localhost"
      ? "theirstory-localhost"
      : "theirstory";

  if (!("indexedDB" in window)) {
    return null;
  }
  return openDB<TheirStorySchema>(dbName, 2, {
    upgrade(db) {
      if (!db.objectStoreNames.contains("recordings")) {
        db.createObjectStore("recordings", {
          keyPath: "id",
        });
      }
    },
  });
};

export const arrayBufferToBlob = (buffer: ArrayBuffer, type: string): Blob => new Blob([buffer], { type: type });
